const TRANSIENT_NETWORK_ERROR =
    /failed to fetch|load failed|networkerror when attempting to fetch|network connection was lost|internet connection appears to be offline/i;

export const isTransientNetworkError = (error) => {
    if (!error) return false;
    if (error.name === 'AbortError') return true;
    return TRANSIENT_NETWORK_ERROR.test(String(error.message ?? error));
};
